import React, { useState } from "react";
import { Box, Typography, Paper, Button, Grid, TextField, InputAdornment} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { DataGrid } from '@mui/x-data-grid';
import { useKeycloak } from '@react-keycloak/web';
import ApiConfig from '../../../utils/services/apiConfig'
import { useNavigate } from "react-router-dom";
import { formatLocalDateTime } from '../../../utils/dateTime';
import { useMountEffect } from '../../../utils/hooks';

function SoftwareManagement() {
  const [softwares, setSoftwares] = useState([])
  const [searchText, setSearchText] = useState('');
  const { keycloak } = useKeycloak();
  const a = new ApiConfig(keycloak)
  const apiConfig = a.api()
  const navigate = useNavigate();

  const getSoftwares = () => {
    Promise.all([
      apiConfig.fetchAllRobotSoftwareVersions(),
    ]).then(results => {
      // console.log(results[0].RobotResponse)
      setSoftwares(results[0].RobotResponse)
    }).catch(error => {
      console.error(error);
    });
  }

  const handleSearch = (event) => {
    setSearchText(event.target.value.toLowerCase());
  };

  const handleDeleteSoftare = (id) => {
    Promise.all([
      apiConfig.deleteRobotSoftwareVersion(id),
    ]).then(results => {
      console.log(results[0])
      getSoftwares()
    }).catch(error => {
      console.error(error);
    });
  }

  const filteredRows = softwares.filter((row) =>
    Object.values(row).some((value) =>
      value.toString().toLowerCase().includes(searchText)
    )
  );

  useMountEffect(() => {

    getSoftwares()

    return () => {
    };

  }, []);

  const columns = [
    { field: "Id", headerName: "ID", flex: 0.1},
    { field: "Name", headerName: "Software Name", flex: 0.1 },
    { field: "Version", headerName: "Software Version", flex: 0.3 },
    { field: "Link", headerName: "Version Link", flex: 0.3 },
    { field: "UpdatedAt", headerName: "Updated At", flex: 0.1, renderCell: (params) => formatLocalDateTime(params.value) },
    {
      field: "actions",
      headerName: "Actions",
      flex: 0.15,
      renderCell: (params) => {

        return (
          <Grid container spacing={1}>
            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
              <Button variant="contained" color="primary" onClick={() => navigate(`/managements/software_management/${params.row.Id}`)}>
                Edit
              </Button>
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
              <Button variant="contained" color="primary" onClick={() => {handleDeleteSoftare(params.row.Id)}}>
                Delete
              </Button>
            </Grid>
          </Grid>
        );
      },
    },
  ];

  return (
    <Box p={2} >
      <Box display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
        sx={{
          flexDirection: {
            xs: 'column',
            sm: 'row',
          },
          gap: {
            xs: 2,
            sm: 0,
          },
        }}>
          <Button variant="contained" color="primary" onClick={() => navigate(`/managements/software_management/create`)}>
            Create New Software Version
          </Button>
          <Typography variant="h4">Robot Softwares</Typography>
          <TextField
            variant="outlined"
            placeholder="Search robot types"
            onChange={handleSearch}
            value={searchText}
            sx={{
              width: {
                xs: '100%',
                sm: '300px',
              },
              backgroundColor: 'background.paper',
              borderRadius: '5px',
              '& .MuiOutlinedInput-root': {
                borderRadius: '5px',
                height: {
                  xs: '40px',
                  sm: '50px',
                },
              },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Box>
      <Paper elevation={3} sx={{ height: "100%", width: "100%", mt: 2 }}>
        <DataGrid rows={filteredRows} columns={columns} pageSize={5} getRowId={(row) => row.Id} rowsPerPageOptions={[5]} />
      </Paper>
    </Box>
  )
}

export default SoftwareManagement;
